import React from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import Login from './Login.js';

const SetNewPasswordDone = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/authentification";

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate(from, { replace: true });
  }

  return (
    <Login>
      <div className="Login-formulaire">
        <form onSubmit={handleSubmit}>
          <p className="Login-info">Votre mot de passe a été modifié avec succès.<br />Veuillez essayer de vous connecter avec votre nouveau mot de passe.</p>
          <button className="Login-rectangle-button" onSubmit={handleSubmit}>Procéder à la connexion</button>
        </form>
      </div>
    </Login>
  );
}

export default SetNewPasswordDone;
